import { Component, OnInit } from '@angular/core';
import { NotificationType } from 'src/app/models/notification.message';
import { DesignationRequest } from 'src/app/models/requests/designation-request';
import { DesignationService } from 'src/app/services/designation.service';
import { NotificationService } from 'src/app/services/notification.service';

@Component({
  selector: 'app-new-designation',
  templateUrl: './new-designation.component.html',
  styleUrls: ['./new-designation.component.css']
})
export class NewDesignationComponent {

  name: string = '';
  description: string = '';


  constructor(private designationService: DesignationService, private notification: NotificationService) { }

  
  onSubmit(): void {
    let DesignationVm: DesignationRequest = {
      name: this.name,
      description: this.description,
    };

    this.designationService.saveDesignation(DesignationVm).subscribe({
      next: (data => {
        
        if (data.responseCode == "00") {
          this.notification.sendMessage({
            message: data.message,
            type: NotificationType.success
          });

          console.debug(`Designation Created successfully ${data}`);
          this.description = '';
          this.name = ''

        }
        else {

          this.notification.sendMessage({
            message: data.message,
            type: NotificationType.error
          });

        }

      }),
      error: ((error: any) => {
        console.log(error.error);
        ;


        this.notification.sendMessage({
          message: error.error.message,
          type: NotificationType.error
        });
      })

    });
  }
}
